export const SET_APP_STATE = "SET_APP_STATE";
export const CLEAR_APP_STATE = "CLEAR_APP_STATE";
export const SET_NAVIGATION_HISTORY = "SET_NAVIGATION_HISTORY";